(function (angular, app) {
    'use strict';

    var NUMBER_SHOWN_ITEMS = 6

    app.controller('AddGiftCardCtrl', [
        '$rootScope', '$scope', '$filter', '$timeout', 'Config', 'Cart', 'PaymentsService', 'options', 'Dialog', 'SP_PAYMENTS', 'User', 'Util', 'summaryCtrl',
        function ($rootScope, $scope, $filter, $timeout, Config, Cart, PaymentsService, options, dialog, SP_PAYMENTS, user, util, summaryCtrl) {
            var addGiftCardCtrl = this,
                _listeners = [],
            _roundCurrencyFilter = $filter('roundCurrency'),
            _multipleGiftCardUsageSettings = util.tryParseJson(Config.retailer.settings.multipleGiftCardUsageSettings || '{}'),
            _giftCardDisplayParsed = Config.retailer.settings.giftCardDisplay ? util.tryParseJson(Config.retailer.settings.giftCardDisplay) : {},
            _giftCardExclusionItemsByMethodId = {};

            addGiftCardCtrl.mainPaymentMethod = options.mainPaymentMethod;
            addGiftCardCtrl.maxAmount = options.maxAmount || null;
            addGiftCardCtrl.giftCardsData = options.giftCardsData || {};
            addGiftCardCtrl.removedGiftCards = [];
            addGiftCardCtrl.giftCardsIndex = {};
            addGiftCardCtrl.giftCardsSettings = Config.retailer.settings.giftCardsSettings ? util.tryParseJson(Config.retailer.settings.giftCardsSettings) : {};
            addGiftCardCtrl.orderTotal = _roundCurrencyFilter(
                Cart.total.finalPriceWithTax + Cart.total.serviceFee.finalPriceWithTax + Cart.total.deliveryCost.finalPriceWithTax
            );
            addGiftCardCtrl.total = addGiftCardCtrl.orderTotal;
            addGiftCardCtrl.giftCardPopupSettings = Config.retailer.settings.checkoutDisplaySettings ? util.tryParseJson(Config.retailer.settings.checkoutDisplaySettings) : {};
            addGiftCardCtrl.giftCardInputRegExp = new RegExp(/^[0-9.-]*$/);
            addGiftCardCtrl.carouselActions = {
                toggleSelectedGiftCard: toggleSelectedGiftCard,
                showAddCardDialog: showAddCardDialog
            };
            addGiftCardCtrl.toggleEllipsisBtn = toggleEllipsisBtn;
            addGiftCardCtrl.toggleSelectedGiftCard = toggleSelectedGiftCard;
            addGiftCardCtrl.showAddCardDialog = showAddCardDialog;
            addGiftCardCtrl.checkGiftCard = checkGiftCard;
            addGiftCardCtrl.redeemGiftCard = redeemGiftCard;
            addGiftCardCtrl.removeCard = removeCard;
            addGiftCardCtrl.isDisableRedeemBtn = isDisableRedeemBtn;
            addGiftCardCtrl.checkAmount = checkAmount;
            addGiftCardCtrl.resetCardDetails = resetCardDetails;
            addGiftCardCtrl.isGiftCardNotEligible = isGiftCardNotEligible;
            addGiftCardCtrl.next = next;
            addGiftCardCtrl.close = close;
            addGiftCardCtrl.isRedeemedGiftCardsExist = isRedeemedGiftCardsExist;
            addGiftCardCtrl.legalText = {};
            addGiftCardCtrl.isValidateCvv = isValidateCvv;
            addGiftCardCtrl.isShowImagesGiftCards = Config.retailer.settings.isShowImagesGiftCards === 'true';
            addGiftCardCtrl.giftCardAccessibilities = Config.retailer.settings.giftCardAccessibilities ? util.tryParseJson(Config.retailer.settings.giftCardAccessibilities) : {};
            addGiftCardCtrl.giftCardOrders = Config.retailer.settings.giftCardOrders ? Config.retailer.settings.giftCardOrders.split(',') : [];
            addGiftCardCtrl.numberScrolledItems = Config.retailer.settings.isScrollFullGiftCards === 'true' ? NUMBER_SHOWN_ITEMS : 1;
            addGiftCardCtrl.isScrollWhenClickOnLastItem = Config.retailer.settings.isScrollFullGiftCards === 'true';
            addGiftCardCtrl.allowAddMultipleGiftCardsByType = allowAddMultipleGiftCardsByType;
            addGiftCardCtrl.getRedeemedGiftCardsByType = getRedeemedGiftCardsByType;

            addGiftCardCtrl.addAnotherCard = addAnotherCard;
            addGiftCardCtrl.cancelAddingNewCard = cancelAddingNewCard;
            addGiftCardCtrl.getGridColumns = getGridColumns;
            addGiftCardCtrl.allowAddMultipleGiftCardsByTypeSettings = allowAddMultipleGiftCardsByTypeSettings;
            addGiftCardCtrl.hasMaximumNumberOfGiftCardsReachedForThisType = hasMaximumNumberOfGiftCardsReachedForThisType;
            addGiftCardCtrl.showZeroBalanceError = showZeroBalanceError;
            addGiftCardCtrl.getBalanceToBePayedForType = getBalanceToBePayedForType;
            addGiftCardCtrl.canShowGiftCardEntryForSelectedType = canShowGiftCardEntryForSelectedType;

            _init();

            function _isMaxOrFiniti(paymentMethodId) {
                return paymentMethodId === SP_PAYMENTS.PAYMENT_METHODS.IDS.MAX_GIFT_CARD ||
                    paymentMethodId === SP_PAYMENTS.PAYMENT_METHODS.IDS.FINITI;
            }

            function _emptyGiftCardData() {
                return { number: null, balance: null };
            }

            function _resetGiftCardDataForType(paymentMethodId) {
                addGiftCardCtrl.giftCardsData[paymentMethodId] = _emptyGiftCardData();
            }

            function _setAddingNewCardFlag(paymentMethodId, isAddingNewCard) {
                if (!addGiftCardCtrl.carouselData.redeemedGiftCards[paymentMethodId]) {
                    return;
                }
                addGiftCardCtrl.carouselData.redeemedGiftCards[paymentMethodId] = angular.extend(
                    {},
                    addGiftCardCtrl.carouselData.redeemedGiftCards[paymentMethodId],
                    { isAddingNewCard: !!isAddingNewCard }
                );
            }

            function _buildDialogPayload(paymentMethodId, overrides) {
                return angular.extend({
                    giftCards: options.giftCards,
                    giftCardsData: angular.copy(addGiftCardCtrl.giftCardsData),
                    redeemedGiftCards: angular.copy(addGiftCardCtrl.carouselData.redeemedGiftCards),
                    maxAmount: addGiftCardCtrl.maxAmount,
                    selectedGiftCard: paymentMethodId,
                    mainPaymentMethod: options.mainPaymentMethod,
                    isUsedCashbackPoints: options.isUsedCashbackPoints,
                    availableUserCashback: options.availableUserCashback,
                    isAddingNewCard: false
                }, overrides || {});
            }

            function _showGiftCardDialog(payload) {
                return dialog.show({
                    templateUrl: 'template/dialogs/add-gift-card/index.html',
                    controller: 'AddGiftCardCtrl',
                    controllerAs: 'addGiftCardCtrl',
                    ariaLabelledby: 'add_gift_card_title',
                    styleClass: 'add-gift-cards-dialog',
                    clickOutsideToClose: false,
                    disableClosing: true,
                    locals: { options: payload },
                    resolve: {
                        summaryCtrl: summaryCtrl
                    }
                });
            }

            function _getGiftCardDisplayCulture() {
                return _giftCardDisplayParsed[Config.language.culture] || {};
            }

            function _applyBalanceToGiftCardData(paymentMethodId, balance) {
                if (!balance) {
                    addGiftCardCtrl.giftCardsData[paymentMethodId].errorMessage = 'gift_card_error_message';
                    return false;
                }
                addGiftCardCtrl.giftCardsData[paymentMethodId].balance = _roundCurrencyFilter(balance);
                addGiftCardCtrl.giftCardsData[paymentMethodId].amount = _roundCurrencyFilter(Math.min(
                    addGiftCardCtrl.giftCardsData[paymentMethodId].balance,
                    getMaxRedeemableForType(paymentMethodId)
                ));
                addGiftCardCtrl.maxAmount = addGiftCardCtrl.giftCardsData[paymentMethodId].amount;
                addGiftCardCtrl.giftCardsData[paymentMethodId].errorMessage = '';
                return true;
            }

            function _applyPaymentDataFromIframe(paymentMethodId, paymentData) {
                addGiftCardCtrl.giftCardsData[paymentMethodId] = angular.extend({}, addGiftCardCtrl.giftCardsData[paymentMethodId], {
                    token: paymentData.token,
                    number: paymentData.cardNumber,
                    lastFourDigits: paymentData.lastFourDigits,
                    queryTransId: paymentData.queryTransId,
                    id: paymentData.id,
                    isCvvRequired: false
                });
                _applyBalanceToGiftCardData(paymentMethodId, paymentData.balance);
            }

            function _startIframeGiftCard(giftCardId, additionalData, isAddingNewCard) {
                if (!_isMaxOrFiniti(giftCardId)) {
                    return;
                }
                if (giftCardId === SP_PAYMENTS.PAYMENT_METHODS.IDS.FINITI) {
                    return setFinitiCard(giftCardId, additionalData, isAddingNewCard);
                }
                return setMaxGiftCard(giftCardId, additionalData, isAddingNewCard);
            }

            function _isAddingNewCard(paymentMethodId) {
                return !!util.getDataByPath(addGiftCardCtrl.carouselData.redeemedGiftCards, paymentMethodId + '.isAddingNewCard');
            }

            function _getExclusionItemsObj(paymentMethodId) {
                if (_giftCardExclusionItemsByMethodId[paymentMethodId]) {
                    return _giftCardExclusionItemsByMethodId[paymentMethodId];
                }
                var items = Config.retailer.giftCardExclusion && Config.retailer.giftCardExclusion.items;
                var exclusionItemsObj = {};
                if (items && items[paymentMethodId]) {
                    items[paymentMethodId].forEach(function (item) {
                        exclusionItemsObj[item.id] = item;
                    });
                }
                _giftCardExclusionItemsByMethodId[paymentMethodId] = exclusionItemsObj;
                return exclusionItemsObj;
            }

            function _addIframeGiftCard(paymentMethodId, additionalData, isAddingNewCard, addCardFn) {
                return addCardFn(additionalData)
                    .then(function (result) {
                        if (result.paymentData) {
                            _applyPaymentDataFromIframe(paymentMethodId, result.paymentData);
                            return _showGiftCardDialog(_buildDialogPayload(paymentMethodId, {
                                isAddingNewCard: isAddingNewCard
                            }));
                        }
                        console.log('Cannot open gift card dialog');
                        backToGiftCardsList(paymentMethodId);
                    })
                    .catch(function (error) {
                        console.log('gift_card_error_message', error);
                        backToGiftCardsList(paymentMethodId);
                    });
            }

            function _init() {
                if(options.isUsedCashbackPoints) {
                    addGiftCardCtrl.total -= options.availableUserCashback;
                }
                _initGiftCardsCarousel();
                _setGiftCardsData();
                _calculateBalanceToBePayed();
                _calculateTextTruncation();
                _setGiftCardGeneralDisplay();
                $timeout(function () { // Wait for carousel to render before adjusting pointer
                    _setGiftCardDisplay(options.isAddingNewCard || false);
                }, 500);
                summaryCtrl._removeRedeemedGiftCard = addGiftCardCtrl.removeCard;

            }

            function toggleEllipsisBtn() {
                addGiftCardCtrl.giftCardDisplay.giftCardsSeeMore = !addGiftCardCtrl.giftCardDisplay.giftCardsSeeMore;

                if(addGiftCardCtrl.giftCardDisplay && addGiftCardCtrl.giftCardDisplay.giftCardsSeeMore && addGiftCardCtrl.originalLegalText) {
                    addGiftCardCtrl.giftCardDisplay.legalText = addGiftCardCtrl.originalLegalText;
                } else {
                    addGiftCardCtrl.giftCardDisplay.legalText = addGiftCardCtrl.truncatedLegalText;
                }
            }

            function toggleSelectedGiftCard (giftCardId, giftCardPosition) {
                if (addGiftCardCtrl.carouselData.selectedGiftCard === giftCardId) {
                    if (_isMaxOrFiniti(giftCardId) && !_hasGiftCardEntryData(giftCardId) && _shouldOpenAddCardDialog(giftCardId)) {
                        return showAddCardDialog(giftCardId);
                    }
                    return;
                }

                addGiftCardCtrl.carouselData.selectedGiftCard = giftCardId;
                addGiftCardCtrl.carouselData.selectedGiftCardData = addGiftCardCtrl.giftCards[addGiftCardCtrl.giftCardsIndex[giftCardId]];
                _calculateBalanceToBePayed();

                if (_hasRedeemedGiftCardsForType(giftCardId)) {
                    _setAddingNewCardFlag(giftCardId, false);
                }

                if (_isMaxOrFiniti(giftCardId) && _shouldOpenAddCardDialog(giftCardId)) {
                    return showAddCardDialog(giftCardId);
                }

                _setGiftCardDisplay();

                $scope.$broadcast('clickItemCarousel', {
                    indexItem: giftCardPosition,
                    callback: _adjustPointerPosition
                });
            }

            function showAddCardDialog(giftCardId, options) {
                options = options || {};
                if (!options.forceAddNew && (_hasGiftCardEntryData(giftCardId) || _hasRedeemedGiftCardsForType(giftCardId))) {
                    if (_isMaxOrFiniti(giftCardId)) {
                        _setGiftCardDisplay();
                        return;
                    }
                    addGiftCardCtrl.giftCardDisplay.giftCardsSeeMore = false;
                    addGiftCardCtrl.carouselData.selectedGiftCard = giftCardId;
                    return;
                }

                if (options.forceAddNew) {
                    _resetGiftCardDataForType(giftCardId);
                }

                // Open iframe when the max gift card has not been added
                dialog.hide(addGiftCardCtrl.carouselData.redeemedGiftCards);
                if(Config.retailer.settings.useDeliveryAddressAsBilling && summaryCtrl.compiledUserAddress) {
                    return dialog.show({
                        templateUrl: 'template/dialogs/use-delivery-address-as-billing/index.html',
                        controller: ['$scope', function ($dialogScope) {
                            var dialogCtrl = this;
                            dialogCtrl.sendUserAddress = false;
                            dialogCtrl.compiledUserAddress = summaryCtrl.compiledUserAddress;
                            var userAddress = user.data.addresses[0];
                            var userCountryName = userAddress && userAddress.country
                            if (userCountryName) {
                                userAddress.countryCode = util.getCountryCode(userCountryName);
                            }
                            $dialogScope.continue = function () {
                                var options = {
                                    sendUserAddress: dialogCtrl.sendUserAddress,
                                    address: userAddress.text1 ? userAddress.text1 : userAddress.text2 ? userAddress.text2 : '',
                                    city: userAddress.city ? userAddress.city : '',
                                    country: userAddress.country ? userAddress.country : '',
                                    countryCode: userAddress.countryCode ? userAddress.countryCode : '',
                                };

                                return _startIframeGiftCard(giftCardId, options, true);
                            };
                        }],
                        controllerAs: 'dialogCtrl',
                        styleClass: 'clear-cart-popup'
                    });
                }
                return _startIframeGiftCard(giftCardId, {}, true);
            }

            function getRedeemedGiftCardsByType(paymentMethodId) {
                return util.getDataByPath(addGiftCardCtrl.carouselData.redeemedGiftCards, paymentMethodId + '.cards') || [];
            }

            function getMultipleGiftCardUsageSettingsByMethodId(paymentMethodId) {
                return _multipleGiftCardUsageSettings[paymentMethodId] || {};
            }

            function allowAddMultipleGiftCardsByTypeSettings(paymentMethodId) {
                return !!getMultipleGiftCardUsageSettingsByMethodId(paymentMethodId).allowSameGiftCardTypeMultipleTimes;
            }

            function hasMaximumNumberOfGiftCardsReachedForThisType(paymentMethodId) {
                var multipleGiftCardUsageSettingsByMethod = getMultipleGiftCardUsageSettingsByMethodId(paymentMethodId);
    
                var giftCardTypeRedemptionLimit = multipleGiftCardUsageSettingsByMethod.giftCardTypeRedemptionLimit || 3;
                var isLimitedToUseGiftCardTypeRedemption = multipleGiftCardUsageSettingsByMethod.isLimitedToUseGiftCardTypeRedemption || false;
                var currentGiftCardCount = util.getDataByPath(addGiftCardCtrl.carouselData.redeemedGiftCards, paymentMethodId + '.cards.length') || 0;
                return isLimitedToUseGiftCardTypeRedemption && currentGiftCardCount >= giftCardTypeRedemptionLimit;
            }
            
            function allowAddMultipleGiftCardsByType(paymentMethodId) {
                var currentGiftCardCount = util.getDataByPath(addGiftCardCtrl.carouselData.redeemedGiftCards, paymentMethodId + '.cards.length') || 0;
                var multipleGiftCardUsageSettingsByMethod = getMultipleGiftCardUsageSettingsByMethodId(paymentMethodId);
    
                var allowSameGiftCardTypeMultipleTimes = multipleGiftCardUsageSettingsByMethod.allowSameGiftCardTypeMultipleTimes || false;
                var isLimitedToUseGiftCardTypeRedemption = multipleGiftCardUsageSettingsByMethod.isLimitedToUseGiftCardTypeRedemption || false;
                var giftCardTypeRedemptionLimit = multipleGiftCardUsageSettingsByMethod.giftCardTypeRedemptionLimit || 3;
                var currentCardNumber = util.getDataByPath(addGiftCardCtrl.giftCardsData, paymentMethodId + '.number') || '';
                if(currentCardNumber.length > 0) {
                    return false;
                }
                if (isLimitedToUseGiftCardTypeRedemption) {
                    return currentGiftCardCount < giftCardTypeRedemptionLimit && getBalanceToBePayedForType(paymentMethodId) > 0;
                }
                return allowSameGiftCardTypeMultipleTimes && getBalanceToBePayedForType(paymentMethodId) > 0;
            }

            function getGridColumns(paymentMethodId) {
                paymentMethodId = paymentMethodId || addGiftCardCtrl.carouselData.selectedGiftCard;
                var redeemedForType = addGiftCardCtrl.carouselData.redeemedGiftCards[paymentMethodId];
                var result = '220px';
                if (allowAddMultipleGiftCardsByTypeSettings(paymentMethodId) && redeemedForType && !_isAddingNewCard(paymentMethodId)) {
                    result += ' 160px';
                }
                result += ' auto';
                return result;
            }
            function addAnotherCard(paymentMethodId, card) {
                if (hasMaximumNumberOfGiftCardsReachedForThisType(paymentMethodId)) {
                    return false;
                }
                card = angular.extend({}, card);
                if (!card.cardNumber) {
                    var hasRedeemed = _hasRedeemedGiftCardsForType(paymentMethodId);

                    if (_isMaxOrFiniti(paymentMethodId)) {
                        if (hasRedeemed) {
                            _setAddingNewCardFlag(paymentMethodId, true);
                        }
                        return showAddCardDialog(paymentMethodId, { forceAddNew: true });
                    }

                    if (!hasRedeemed) {
                        return false;
                    }

                    _setAddingNewCardFlag(paymentMethodId, true);
                    return false;
                }

                var maxTotalForType = _roundCurrencyFilter(addGiftCardCtrl.orderTotal - _calculateAmountGiftCardExcludeItem(paymentMethodId));
                var maxRedeemable = getMaxRedeemableForType(paymentMethodId);
                if (card.amount > maxRedeemable) {
                    card.amount = maxRedeemable;
                }

                if (!addGiftCardCtrl.carouselData.redeemedGiftCards[paymentMethodId] || !addGiftCardCtrl.carouselData.redeemedGiftCards[paymentMethodId].cards) {
                    addGiftCardCtrl.carouselData.redeemedGiftCards[paymentMethodId] = {
                        cards: [card],
                        amount: card.amount || 0,
                        isAddingNewCard: false
                    };
                } else {
                    if (addGiftCardCtrl.carouselData.redeemedGiftCards[paymentMethodId] && addGiftCardCtrl.carouselData.redeemedGiftCards[paymentMethodId].cards.some(function (c) { return c.cardNumber === card.cardNumber; })) {
                        addGiftCardCtrl.giftCardsData[paymentMethodId].errorMessage = 'gift_card_already_added';
                        return false;
                    }
                    else {
                        addGiftCardCtrl.carouselData.redeemedGiftCards[paymentMethodId].cards.push(card);
                        addGiftCardCtrl.carouselData.redeemedGiftCards[paymentMethodId].amount = _roundCurrencyFilter(addGiftCardCtrl.carouselData.redeemedGiftCards[paymentMethodId].amount + Number(card.amount || 0));
                        if (addGiftCardCtrl.carouselData.redeemedGiftCards[paymentMethodId].amount > maxTotalForType) {
                            addGiftCardCtrl.carouselData.redeemedGiftCards[paymentMethodId].amount = maxTotalForType;
                        }
                        _setAddingNewCardFlag(paymentMethodId, false);
                        addGiftCardCtrl.carouselData.redeemedGiftCards[paymentMethodId].methodId = paymentMethodId;
                    }
                }
                
                return true;
            }

            function checkGiftCard (paymentMethodId) {
                addGiftCardCtrl.giftCardsData[paymentMethodId] = angular.extend({}, addGiftCardCtrl.giftCardsData[paymentMethodId]);
                addGiftCardCtrl.giftCardsData[paymentMethodId].errorMessage = '';
                var cardNumber = addGiftCardCtrl.giftCardsData[paymentMethodId].number;
                var cvv = addGiftCardCtrl.giftCardsData[paymentMethodId].cvv;
                var giftCard = findGiftCard(paymentMethodId);
                var finalizedNumber = giftCard && giftCard.isCvvRequired &&
                paymentMethodId === SP_PAYMENTS.PAYMENT_METHODS.IDS.NOFSHONIT ? cardNumber + cvv : cardNumber;

                return PaymentsService.getGiftCardBalance(paymentMethodId, finalizedNumber)
                  .then(function (result) {
                    addGiftCardCtrl.giftCardsData[paymentMethodId].token = result.token;
                    addGiftCardCtrl.giftCardsData[paymentMethodId].lastFourDigits = result.lastFourDigits ||
                        (addGiftCardCtrl.giftCardsData[paymentMethodId].number && addGiftCardCtrl.giftCardsData[paymentMethodId].number.slice(-4));
                    _applyBalanceToGiftCardData(paymentMethodId, result.balance);
                  }).catch(function () {
                      addGiftCardCtrl.giftCardsData[paymentMethodId] = angular.extend({}, addGiftCardCtrl.giftCardsData[paymentMethodId], { errorMessage : 'gift_card_error_message'});
                  });
            }

            function setMaxGiftCard(paymentMethodId, additionalData, isAddingNewCard) {
                return _addIframeGiftCard(paymentMethodId, additionalData, isAddingNewCard, PaymentsService.addMaxGiftCard.bind(PaymentsService));
            }

            function redeemGiftCard(paymentMethodId) {
                if (_isMaxOrFiniti(paymentMethodId)) {
                    if (!addGiftCardCtrl.giftCardsData[paymentMethodId].cvv || isNaN(addGiftCardCtrl.giftCardsData[paymentMethodId].cvv)) {
                        addGiftCardCtrl.carouselData.selectedGiftCardData.isCvvRequired = true;
                        return;
                    } else {
                        addGiftCardCtrl.carouselData.selectedGiftCardData.isCvvRequired = false;
                    }
                }

                if(addGiftCardCtrl.removedGiftCards[paymentMethodId]) {
                    delete addGiftCardCtrl.removedGiftCards[paymentMethodId];
                }

                var giftCardFormData = addGiftCardCtrl.giftCardsData[paymentMethodId];
                var redeemAmount = _roundCurrencyFilter(Number(giftCardFormData.amount) || 0);
                var maxRedeemable = getMaxRedeemableForType(paymentMethodId);
                if (redeemAmount > maxRedeemable) {
                    redeemAmount = maxRedeemable;
                }

                var card = {
                    methodId: paymentMethodId,
                    amount: redeemAmount,
                    cardNumber: giftCardFormData.number,
                    token: giftCardFormData.token,
                    lastFourDigits: giftCardFormData.lastFourDigits,
                    cvv: giftCardFormData.cvv,
                    queryTransId: giftCardFormData.queryTransId,
                    id: giftCardFormData.id,
                    paymentsNumber: 1
                };
                if(!addAnotherCard(paymentMethodId, card)) {
                    return;
                }

                _calculateBalanceToBePayed();
                _resetGiftCardDataForType(paymentMethodId);
            }

            function setFinitiCard(paymentMethodId, additionalData, isAddingNewCard) {
                return _addIframeGiftCard(paymentMethodId, additionalData, isAddingNewCard, PaymentsService.addFinitiCard.bind(PaymentsService));
            }

            function cancelAddingNewCard(paymentMethodId) {
                if (!paymentMethodId) {
                    return;
                }
                _setAddingNewCardFlag(paymentMethodId, false);
                _resetGiftCardDataForType(paymentMethodId);
                _calculateBalanceToBePayed();
            }

            function backToGiftCardsList(paymentMethodId) {
                if (!_hasRedeemedGiftCardsForType(paymentMethodId)) {
                    return;
                }
                var redeemedGiftCards = angular.copy(addGiftCardCtrl.carouselData.redeemedGiftCards);
                if (redeemedGiftCards[paymentMethodId]) {
                    redeemedGiftCards[paymentMethodId].isAddingNewCard = false;
                }
                var giftCardsData = angular.copy(addGiftCardCtrl.giftCardsData);
                giftCardsData[paymentMethodId] = _emptyGiftCardData();
                return _showGiftCardDialog(_buildDialogPayload(paymentMethodId, {
                    giftCardsData: giftCardsData,
                    redeemedGiftCards: redeemedGiftCards,
                    isAddingNewCard: false
                }));
            }
            function removeCard(paymentMethodId, cardNumber) {
                var cards = util.getDataByPath(addGiftCardCtrl.carouselData.redeemedGiftCards, paymentMethodId + '.cards') || [];
                var cardIndex = cards.findIndex(function (card) { return card.cardNumber === cardNumber; });
                var shouldOpenAddCardDialog = false;

                if (cardIndex !== -1) {
                    addGiftCardCtrl.removedGiftCards[paymentMethodId] = cards[cardIndex];
                    cards.splice(cardIndex, 1);
                    if (cards.length === 0) {
                        delete addGiftCardCtrl.carouselData.redeemedGiftCards[paymentMethodId];
                        _resetGiftCardDataForType(paymentMethodId);
                        _adjustPointerPosition();
                        shouldOpenAddCardDialog = _isMaxOrFiniti(paymentMethodId);
                    } else {
                        addGiftCardCtrl.carouselData.redeemedGiftCards[paymentMethodId].cards = cards;
                        addGiftCardCtrl.carouselData.redeemedGiftCards[paymentMethodId].amount = _roundCurrencyFilter(cards.reduce(function (acc, card) { return acc + card.amount; }, 0));
                    }
                }

                _calculateBalanceToBePayed();

                if (shouldOpenAddCardDialog) {
                    showAddCardDialog(paymentMethodId, { forceAddNew: true });
                }

                return addGiftCardCtrl.carouselData.redeemedGiftCards;
            }

            function resetCardDetails(paymentMethodId) {
                _resetGiftCardDataForType(paymentMethodId);
                _calculateBalanceToBePayed();

                if (_isMaxOrFiniti(paymentMethodId)) {
                    return showAddCardDialog(paymentMethodId, { forceAddNew: true });
                }
            }

            function _hasGiftCardEntryData(paymentMethodId) {
                var giftCardData = addGiftCardCtrl.giftCardsData[paymentMethodId];
                return !!(giftCardData && (giftCardData.number || giftCardData.token));
            }

            function _hasRedeemedGiftCardsForType(giftCardId) {
                return getRedeemedGiftCardsByType(giftCardId).length > 0;
            }

            function _shouldOpenAddCardDialog(giftCardId) {
                return !_hasGiftCardEntryData(giftCardId) && !_hasRedeemedGiftCardsForType(giftCardId);
            }

            function getBalanceToBePayedForType(paymentMethodId) {
                var exclusionAmount = _calculateAmountGiftCardExcludeItem(paymentMethodId);
                var maxForType = _roundCurrencyFilter(addGiftCardCtrl.orderTotal - exclusionAmount);
                var redeemedForType = addGiftCardCtrl.carouselData.redeemedGiftCards[paymentMethodId];
                var redeemedAmount = redeemedForType ? (redeemedForType.amount || 0) : 0;
                var remaining = _roundCurrencyFilter(maxForType - redeemedAmount);
                return remaining > 0 ? remaining : 0;
            }

            function getMaxRedeemableForType(paymentMethodId) {
                var balanceForType = getBalanceToBePayedForType(paymentMethodId);
                var giftCardData = addGiftCardCtrl.giftCardsData[paymentMethodId] || {};
                var cardBalance = Number(giftCardData.balance) || 0;
                var maxRedeemable = 0;

                if (balanceForType > 0) {
                    maxRedeemable = cardBalance > 0 ? _roundCurrencyFilter(Math.min(balanceForType, cardBalance)) : balanceForType;
                } else if (_hasGiftCardEntryData(paymentMethodId) && cardBalance > 0) {
                    if (addGiftCardCtrl.maxAmount > 0) {
                        maxRedeemable = _roundCurrencyFilter(Math.min(cardBalance, addGiftCardCtrl.maxAmount));
                    } else if (addGiftCardCtrl.orderTotal > 0) {
                        maxRedeemable = _roundCurrencyFilter(Math.min(cardBalance, addGiftCardCtrl.orderTotal));
                    }
                }

                return _capRedeemableAmountByOrderBalance(maxRedeemable);
            }

            function _getGlobalRemainingOrderBalance() {
                var baseTotal = addGiftCardCtrl.total > 0 ? addGiftCardCtrl.total : addGiftCardCtrl.orderTotal;
                if (!baseTotal || isNaN(baseTotal)) {
                    baseTotal = 0;
                }
                var remaining = _roundCurrencyFilter(baseTotal);
                angular.forEach(Object.keys(addGiftCardCtrl.carouselData.redeemedGiftCards || {}), function (giftCardId) {
                    var redeemedGiftCard = addGiftCardCtrl.carouselData.redeemedGiftCards[giftCardId];
                    var redeemedGiftCardAmount = redeemedGiftCard ? (redeemedGiftCard.amount || 0) : 0;
                    remaining = _roundCurrencyFilter(remaining - redeemedGiftCardAmount);
                });
                return remaining > 0 ? remaining : 0;
            }

            function _capRedeemableAmountByOrderBalance(amount) {
                var globalRemaining = _getGlobalRemainingOrderBalance();
                if (globalRemaining <= 0) {
                    return 0;
                }
                if (!amount || amount <= 0) {
                    return globalRemaining;
                }
                return _roundCurrencyFilter(Math.min(amount, globalRemaining));
            }

            function canShowGiftCardEntryForSelectedType() {
                var paymentMethodId = addGiftCardCtrl.carouselData.selectedGiftCard;
                return getBalanceToBePayedForType(paymentMethodId) > 0 ||
                    !!addGiftCardCtrl.carouselData.redeemedGiftCards[paymentMethodId] ||
                    _hasGiftCardEntryData(paymentMethodId);
            }

            function showZeroBalanceError() {
                var paymentMethodId = addGiftCardCtrl.carouselData.selectedGiftCard;
                return getBalanceToBePayedForType(paymentMethodId) <= 0 &&
                    !addGiftCardCtrl.carouselData.redeemedGiftCards[paymentMethodId];
            }

            function _calculateAmountGiftCardExcludeItem(paymentMethodId) {
                var giftCardExclusionItemsObj = _getExclusionItemsObj(paymentMethodId);
                var totalAmount = 0;
                if (Object.keys(giftCardExclusionItemsObj).length) {
                    Object.keys(Cart.lines).forEach(function (lineId) {
                        var cartLine = Cart.lines[lineId];
                        var productInLine = cartLine.product;
                        var needToExclude = false;
                        if (productInLine && productInLine.family && productInLine.family.categories) {
                            productInLine.family.categories.some(function (category) {
                                var itemGiftCardExclusion = giftCardExclusionItemsObj[category.id];
                                if (category && itemGiftCardExclusion) {
                                    if (itemGiftCardExclusion.familyId) {
                                        if (productInLine.family.id === itemGiftCardExclusion.familyId) {
                                            needToExclude = true;
                                            return true;
                                        }
                                    } else {
                                        needToExclude = true;
                                        return true;
                                    }
                                }
                            });
                            if (needToExclude) {
                                totalAmount += Number(Math.abs(cartLine.finalPriceWithTax));
                            }
                        }
                    });
                }
                return totalAmount;
            }

            function checkAmount(paymentMethodId) {
                addGiftCardCtrl.giftCardsData[paymentMethodId].wrongAmountError = '';

                if(addGiftCardCtrl.giftCardsData[paymentMethodId].balance && addGiftCardCtrl.giftCardsData[paymentMethodId].amount > addGiftCardCtrl.giftCardsData[paymentMethodId].balance) {
                    addGiftCardCtrl.giftCardsData[paymentMethodId].wrongAmountError = 'amount_exceeds_balance';
                    return;
                }

                var maxRedeemable = getMaxRedeemableForType(paymentMethodId);
                if (addGiftCardCtrl.giftCardsData[paymentMethodId].amount > maxRedeemable) {
                    addGiftCardCtrl.giftCardsData[paymentMethodId].wrongAmountError = 'wrong_gift_card_amount_error';
                    return;
                }
            }

            function isDisableRedeemBtn(paymentMethodId) {
                var giftCardData = addGiftCardCtrl.giftCardsData[paymentMethodId] || {},
                    maxRedeemable = getMaxRedeemableForType(paymentMethodId),
                    existCvv = giftCardData.cvv,
                    existAmount = giftCardData.amount,
                    existBalance = giftCardData.balance,
                    amount = Number(giftCardData.amount),
                    invalidAmount = isNaN(amount) || amount <= 0
                    || (existBalance && amount > Number(giftCardData.balance))
                    || amount > maxRedeemable;

                if (!existCvv && (_isMaxOrFiniti(paymentMethodId) ||
                    paymentMethodId === SP_PAYMENTS.PAYMENT_METHODS.IDS.NOFSHONIT)) {
                    return true;
                }

                return !existAmount || !existBalance || maxRedeemable <= 0 || invalidAmount;
            }

            function isGiftCardNotEligible() {
                return (addGiftCardCtrl.carouselData.selectedGiftCard === SP_PAYMENTS.PAYMENT_METHODS.IDS.TAV_PLUS || addGiftCardCtrl.carouselData.selectedGiftCard === SP_PAYMENTS.PAYMENT_METHODS.IDS.TAV_PLUS_LIGHT) && addGiftCardCtrl.mainPaymentMethod !== SP_PAYMENTS.PAYMENT_METHODS.IDS.CREDIT_CARD;
            }

            function close () {
                var paymentMethodId = addGiftCardCtrl.carouselData.selectedGiftCard;
                if (paymentMethodId && _isAddingNewCard(paymentMethodId) && _hasRedeemedGiftCardsForType(paymentMethodId)) {
                    cancelAddingNewCard(paymentMethodId);
                    return;
                }

                var redeemedGiftCards = Object.values(addGiftCardCtrl.carouselData.redeemedGiftCards);
                if (!redeemedGiftCards || !redeemedGiftCards.length) {
                    dialog.hide({});
                    return;
                }

                if(addGiftCardCtrl.removedGiftCards) {
                    angular.extend(addGiftCardCtrl.carouselData.redeemedGiftCards, addGiftCardCtrl.removedGiftCards);
                }
                _calculateTotalGiftCard();
                dialog.hide();
            }

            function next() {
                _calculateTotalGiftCard();
                dialog.hide(addGiftCardCtrl.carouselData.redeemedGiftCards);
            }

            function _calculateTotalGiftCard() {
                // For Max/Finiti, the dialog is forced to close leading to missing totalGiftCard data in summaryCtrl
                if (addGiftCardCtrl.carouselData.redeemedGiftCards[SP_PAYMENTS.PAYMENT_METHODS.IDS.MAX_GIFT_CARD] ||
                    addGiftCardCtrl.carouselData.redeemedGiftCards[SP_PAYMENTS.PAYMENT_METHODS.IDS.FINITI]
                ) {
                    summaryCtrl.totalPriceForPointsCalculation += summaryCtrl.totalGiftCards || 0;
                    summaryCtrl.totalGiftCards = 0;
                    summaryCtrl.redeemedGiftCards = addGiftCardCtrl.carouselData.redeemedGiftCards;
                    summaryCtrl.redeemedGiftCardIds = Object.keys(summaryCtrl.redeemedGiftCards);
                    angular.forEach(summaryCtrl.redeemedGiftCardIds, function (giftCardId) {
                        summaryCtrl.totalGiftCards += summaryCtrl.redeemedGiftCards[giftCardId].amount;
                    });

                    if(summaryCtrl.userCashbackLoyalty) {
                        summaryCtrl.totalPriceForPointsCalculation -= summaryCtrl.totalGiftCards || 0;
                        summaryCtrl.availableUserCashback -= summaryCtrl.totalGiftCards || 0;
                        _calculateUserPoints();
                    }
                }
            }

            function _calculateUserPoints() {
                if(summaryCtrl.totalPriceForPointsCalculation > 0) {
                    var points = summaryCtrl.totalPriceForPointsCalculation / summaryCtrl.activeCashbackLoyalty.moneyToPointRatio;
                    summaryCtrl.currentOrderPoints = Number(points.toFixed(2));
                } else {
                    summaryCtrl.currentOrderPoints = null;
                }
            }

            function _setGiftCardsData() {
                angular.forEach(addGiftCardCtrl.giftCards, function (giftCard) {
                    if (!addGiftCardCtrl.giftCardsData[giftCard.paymentMethodId]) {
                        addGiftCardCtrl.giftCardsData[giftCard.paymentMethodId] = _emptyGiftCardData();
                    }
                });
            }

            function _calculateBalanceToBePayed() {
                addGiftCardCtrl.carouselData.balanceToBePayed = _getGlobalRemainingOrderBalance();
            }

            function _setGiftCardGeneralDisplay() {
                addGiftCardCtrl.giftCardGeneralDisplay = _getGiftCardDisplayCulture();
            }

            function _setGiftCardDisplay(isAddingNewCard) {
                var cultureDisplay = _getGiftCardDisplayCulture();
                var selectedGiftCard = addGiftCardCtrl.carouselData.selectedGiftCard;

                if (!selectedGiftCard) {
                    return;
                }

                if (cultureDisplay.config) {
                    addGiftCardCtrl.giftCardDisplay = cultureDisplay.config[selectedGiftCard] || {};
                    var MAX_TRUNCATED_LEGAL_TEXT_LENGTH = 256;

                    if (addGiftCardCtrl.giftCardDisplay.legalText) {
                        addGiftCardCtrl.originalLegalText = addGiftCardCtrl.giftCardDisplay.legalText;
                        if (addGiftCardCtrl.giftCardDisplay.legalText.length > MAX_TRUNCATED_LEGAL_TEXT_LENGTH) {
                            addGiftCardCtrl.truncatedLegalText = addGiftCardCtrl.giftCardDisplay.legalText.slice(0, MAX_TRUNCATED_LEGAL_TEXT_LENGTH) + '...';
                            addGiftCardCtrl.giftCardDisplay.legalText = addGiftCardCtrl.truncatedLegalText;
                            addGiftCardCtrl.giftCardDisplay.showEllipsisBtn = true;
                        }
                    }

                    addGiftCardCtrl.giftCardDisplay.giftCardsSeeMore = false;
                }

                if (isAddingNewCard) {
                    _setAddingNewCardFlag(selectedGiftCard, true);
                }
                _adjustPointerPosition();
            }

            function _adjustPointerPosition() {
                $timeout(function () {
                    var itemSelectedElm = document.querySelector('.gift-card.open-card');
                    var itemSelectedRect = itemSelectedElm ? itemSelectedElm.getBoundingClientRect() : null;
                    var cardDetailsWrapperElm = document.querySelector('.card-details-wrapper');
                    var cardDetailsWrapperRect = cardDetailsWrapperElm ? cardDetailsWrapperElm.getBoundingClientRect() : null;

                    if (itemSelectedRect && cardDetailsWrapperRect) {
                        var cardPointer = document.querySelector('.card-pointer');
                        var newPos = itemSelectedRect.x - cardDetailsWrapperRect.x < cardDetailsWrapperRect.width - itemSelectedRect.width / 2 ? itemSelectedRect.x - cardDetailsWrapperRect.x + itemSelectedRect.width / 2 : itemSelectedRect.width / 2;
                        cardPointer.style.left = newPos - 10 + 'px';
                    }
                }, 0);
            }

            function _calculateTextTruncation() {
                $timeout(function() {
                    var legalTextEl = document.querySelector('.legal-text-wrapper > span.text');
                    if(legalTextEl) {
                        var scrollHeight = legalTextEl.scrollHeight;
                        var clientHeight = legalTextEl.clientHeight;

                        if(scrollHeight > clientHeight) {
                            addGiftCardCtrl.showSeeMoreBtn = true;
                        }
                    }
                }, 0)
            }

            function _reorderAndIndexGiftCards(giftCards) {
                if (!addGiftCardCtrl.giftCardOrders || !addGiftCardCtrl.giftCardOrders.length) {
                    // If gift card orders has not been configured in BO, use order of gift cards responded from API
                    angular.forEach(giftCards, function (giftCard, index) {
                        addGiftCardCtrl.giftCardsIndex[giftCard.paymentMethodId] = index;
                    });

                    return giftCards;
                }

                var mapPaymentIdToGiftCard = {}
                giftCards.forEach(function (giftCard) {
                    mapPaymentIdToGiftCard[giftCard.paymentMethodId] = giftCard
                })

                var giftCardsNewOrder = [];
                angular.forEach(addGiftCardCtrl.giftCardOrders, function (paymentMethodId) {
                    if (!mapPaymentIdToGiftCard[paymentMethodId]) return;
                    giftCardsNewOrder.push(mapPaymentIdToGiftCard[paymentMethodId])
                    addGiftCardCtrl.giftCardsIndex[paymentMethodId] = giftCardsNewOrder.length - 1;
                });

                return giftCardsNewOrder;
            }
            
            function isRedeemedGiftCardsExist() {
                var selectedGiftCard = addGiftCardCtrl.carouselData.selectedGiftCard;
                var redeemedGiftCardsValues = Object.values(addGiftCardCtrl.carouselData.redeemedGiftCards);
                if (!redeemedGiftCardsValues.length) {
                    return false;
                }
                if (_isAddingNewCard(selectedGiftCard)) {
                    return false;
                }
                if (!_isMaxOrFiniti(selectedGiftCard)) {
                    return true;
                }
                return getRedeemedGiftCardsByType(selectedGiftCard).length > 0;
            }

            function isValidateCvv(){
                return !isNaN(addGiftCardCtrl.giftCardsData[addGiftCardCtrl.carouselData.selectedGiftCard].cvv) && addGiftCardCtrl.giftCardsData[addGiftCardCtrl.carouselData.selectedGiftCard].cvv.length > 0;
            }

            function findGiftCard(paymentMethodId) {
                var index = addGiftCardCtrl.giftCardsIndex[paymentMethodId];
                if (isNaN(index) || index < 0) {
                    return {};
                }

                return addGiftCardCtrl.giftCards[index];
            }

            function _initGiftCardsCarousel() {
                var cultureDisplay = _getGiftCardDisplayCulture();
                addGiftCardCtrl.giftCards = options.giftCards ? options.giftCards : [];

                // If settings allow display images, load images
                if (addGiftCardCtrl.isShowImagesGiftCards && cultureDisplay.config) {
                    addGiftCardCtrl.giftCards.forEach(function (giftCard) {
                        var typeDisplay = cultureDisplay.config[giftCard.paymentMethodId];
                        giftCard.giftCardCover = typeDisplay ? typeDisplay.giftCardCover : '';
                    });
                }

                // Load Accessibilities for gift cards
                addGiftCardCtrl.giftCards.forEach(function (giftCard) {
                    giftCard.accessibilityName = addGiftCardCtrl.giftCardAccessibilities[giftCard.paymentMethodId] && addGiftCardCtrl.giftCardAccessibilities[giftCard.paymentMethodId][Config.language.id] ? addGiftCardCtrl.giftCardAccessibilities[giftCard.paymentMethodId][Config.language.id] : '';
                });

                addGiftCardCtrl.giftCards = _reorderAndIndexGiftCards(addGiftCardCtrl.giftCards);

                var selectedGiftCard = options.selectedGiftCard || addGiftCardCtrl.giftCards[0].paymentMethodId;
                var indexOfSelectedGiftCard = addGiftCardCtrl.giftCardsIndex.hasOwnProperty(selectedGiftCard) ? addGiftCardCtrl.giftCardsIndex[selectedGiftCard] : 0;
                addGiftCardCtrl.carouselData = {
                    selectedGiftCard: selectedGiftCard,
                    balanceToBePayed: 0,
                    redeemedGiftCards: options.redeemedGiftCards || {},
                    selectedGiftCardData: addGiftCardCtrl.giftCards[indexOfSelectedGiftCard] || {},
                    isShowImagesGiftCards: addGiftCardCtrl.isShowImagesGiftCards
                };
            }

            _listeners.push($scope.$watch(function (){
                return addGiftCardCtrl.giftCardsData && addGiftCardCtrl.giftCardsData[addGiftCardCtrl.carouselData.selectedGiftCard] && addGiftCardCtrl.giftCardsData[addGiftCardCtrl.carouselData.selectedGiftCard].cvv
            }, function() {
                if (_isMaxOrFiniti(addGiftCardCtrl.carouselData.selectedGiftCard) &&
                  addGiftCardCtrl.giftCardsData[addGiftCardCtrl.carouselData.selectedGiftCard]
                ) {
                    if (!addGiftCardCtrl.giftCardsData[addGiftCardCtrl.carouselData.selectedGiftCard].cvv && addGiftCardCtrl.carouselData.selectedGiftCardData.isCvvRequired) {
                        addGiftCardCtrl.carouselData.selectedGiftCardData.isCvvRequired = false;
                        return;
                    }
                    if (addGiftCardCtrl.carouselData.selectedGiftCardData.isCvvRequired) {
                        var cvv = addGiftCardCtrl.giftCardsData[addGiftCardCtrl.carouselData.selectedGiftCard].cvv;
                        if (cvv && cvv.length > 2 && !isNaN(cvv)) {
                            addGiftCardCtrl.carouselData.selectedGiftCardData.isCvvRequired = false;
                        }
                    }
                }
            }));

            util.destroyListeners($scope, _listeners);
    }]);
})(angular, app);
